export enum Path {
    root = '/',

    login = '/login',
    oauthLoginSuccess = '/oauthLoginSuccess',
    oauthLoginError = '/oauthLoginError',

    logout = '/logout',

    profile = '/profile',

    users = '/users',
    internalUsers = '/users/internal',
    editUser = '/users/internal/:userId',
    createUser = '/users/internal/new',
    externalUsers = '/users/external',
    externalUser = '/users/external/:userId',
    createExternalUser = '/users/external/new',

    customers = '/customers',
    editCustomer = '/customers/:customerId',
    createCustomer = '/customers/new',

    licenses = '/licenses',
    editLicense = '/licenses/:licenseId',
    createLicense = '/licenses/new',

    installations = '/installations',
    installationDetails = '/customer/:customerId/installation/:installationId',

    appliances = '/appliances',
    applianceDetails = '/appliances/:serialNumber',

    billing = '/billing',
    billingDetails = '/billing/detail',

    // New minute-based billing routes
    billing2 = '/billing2',
    billing2Details = '/billing2/detail',

    auditLog = '/audit-log',
    ai = '/ai',
    aiSettings = '/ai/settings',
    aiConversation = '/ai/:installationId/:threadId',

    settings = '/settings',
}

export const INITIAL_PATH = Path.installations

export function makeEditUserPath(userId: string) {
    return Path.editUser.replace(':userId', userId)
}
export function makeExternalUserPath(userId: string) {
    return Path.externalUser.replace(':userId', userId)
}
export function makeEditCustomerPath(customerId: string) {
    return Path.editCustomer.replace(':customerId', customerId)
}
export function makeEditLicensePath(licenseId: string) {
    return Path.editLicense.replace(':licenseId', licenseId)
}

export function makeInstallationDetailsPath({
    customerId,
    installationId,
}: {
    customerId: string
    installationId: string
}) {
    return Path.installationDetails.replace(':customerId', customerId).replace(':installationId', installationId)
}

export function makeApplianceDetailsPath(serialNumber: string) {
    return Path.applianceDetails.replace(':serialNumber', encodeURIComponent(serialNumber))
}

export function makeAiConversationPath(installationId: string, threadId: string) {
    return Path.aiConversation.replace(':installationId', installationId).replace(':threadId', threadId)
}

export function makeCustomerAppliancesPath(customerId: string) {
    const searchParams = new URLSearchParams({ customerId })
    return `${Path.appliances}?${searchParams.toString()}`
}
